export default {
  "content": "<title>Checkmark Done Circle</title><path d=\"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M368 192L256.13 320l-47.95-48m-16.23 48L144 272m161.71-80l-51.55 59\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};